module.exports = __webpack_public_path__ + "b158fedd3958bac02e28b359f6eab593.png";